import { apiGet, apiPatch } from './client';
import type {
  AgendaAction,
  AgendaActionBatchRequest,
  AgendaCategory,
  AgendaCategoryBatchRequest,
  ValuationType,
  ValuationTypeBatchRequest,
} from '../types/Agenda';

// All three are Central (bank-wide) — NoTenantContext, no X-Tenant-Id needed.

export function getAgendaActions(): Promise<AgendaAction[]> {
  return apiGet<AgendaAction[]>('/api/agenda-actions');
}

export function saveAgendaActionsBatch(
  added: AgendaAction[],
  modified: AgendaAction[],
  deletedIds: number[],
): Promise<AgendaAction[]> {
  return apiPatch<AgendaActionBatchRequest, AgendaAction[]>(
    '/api/agenda-actions/batch',
    { added, modified, deleted: deletedIds },
  );
}

export function getAgendaCategories(): Promise<AgendaCategory[]> {
  return apiGet<AgendaCategory[]>('/api/agenda-categories');
}

export function saveAgendaCategoriesBatch(
  added: AgendaCategory[],
  modified: AgendaCategory[],
  deletedIds: number[],
): Promise<AgendaCategory[]> {
  return apiPatch<AgendaCategoryBatchRequest, AgendaCategory[]>(
    '/api/agenda-categories/batch',
    { added, modified, deleted: deletedIds },
  );
}

export function getValuationTypes(): Promise<ValuationType[]> {
  return apiGet<ValuationType[]>('/api/valuation-types');
}

export function saveValuationTypesBatch(
  added: ValuationType[],
  modified: ValuationType[],
  deletedIds: number[],
): Promise<ValuationType[]> {
  return apiPatch<ValuationTypeBatchRequest, ValuationType[]>(
    '/api/valuation-types/batch',
    { added, modified, deleted: deletedIds },
  );
}
